import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import liff from '@line/liff';
import { Observable } from 'rxjs';

@Injectable()
export class LineGuard implements CanActivate {
    states = {
        name: '',
        userLineID: '',
        pictureUrl: ''
    };
    constructor(private router: Router, private auth: AuthService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        return new Promise(async (resolve, reject) => {
            // await liff.init({ liffId: "1657188415-2zkOm7NJ" }) //สารวิทยา
            await liff.init({ liffId: "1657336079-jAPL7gYR" }) //นาบอน
            // await liff.init({ liffId: "1657421144-OXJqkb5g" }) //sanbox
            if (liff.isInClient()) {
                let profile = await liff.getProfile();
                this.states.userLineID = profile.userId;
                this.states.name = profile.displayName;
                await this.auth.doLine(profile.userId).then(resp => {
                    if (resp.user) {
                        localStorage.setItem('currentUser', JSON.stringify(resp.user));
                    } else {
                        localStorage.setItem('currentUser', JSON.stringify(resp));
                    }
                    localStorage.setItem('token', resp.token);
                }).catch(err => {
                    this.router.navigate(['/system/auth'], { queryParams: { returnUrl: state.url.split("#")[0] } });

                })

                resolve(true);
            } else {
                if (!liff.isLoggedIn()) {
                    liff.login();
                    // The user can use an API that requires an access token, such as liff.getProfile().
                }
                this.router.navigate(['/system/auth'], { queryParams: { returnUrl: state.url } });
                resolve(false);
            }

        });


    }

}
